import { ICountryData } from '@/types';
import {
    languages as languagesDict,
    countries as countriesDict,
    localeDict,
} from '@/consts/languageAccordance';
import { config } from '@/config';

export const getAccountLocale = (
    preferredLanguageId: number | undefined | null,
    countryCode: string | undefined,
    countries: ICountryData[] | undefined,
) => {
    if (!countryCode) return undefined;

    const country = countries?.find(
        (c) => c.countryCode.toLowerCase() === countryCode.toLowerCase(),
    );

    if (country) {
        const preferredLanguageCode = Object.values(languagesDict).find(
            (l) => l.id === preferredLanguageId,
        )?.code as string;
        const countryCode = Object.values(countriesDict).find(
            (c) => c.code3 === country.countryCode,
        )?.code as string;
        if (!countryCode) return undefined;

        const defaultLanguageCode = Object.keys(localeDict)
            .find((key) => key.split('-')[1].toLowerCase() === countryCode.toLowerCase())
            ?.split('-')[0] as string;

        const localeString = `${preferredLanguageCode ?? defaultLanguageCode}-${countryCode}`;

        return validateLocaleString(localeString);
    } else {
        return undefined;
    }
};

const validateLocaleString = (localeString: string) => {
    return localeString in localeDict && config.locales.includes(localeString)
        ? localeString
        : undefined;
};
